<form class="card mt-2">
  <div class="card-body">
    <div class="float-right">
      <button *ngIf="canViewKraReport" type="button" routerLink="/employee-review/report/kra" class="btn btn-secondary">KRAs</button>
    </div>
    <h2 class="mb-3">Completed Oversight Reviews</h2>
    <div class="mb-3">

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Employee:</h5>
        </div>
        <div class="col-10">
          <div class="ml-2 w-100 mb-2">
            <p-autoComplete [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" [(ngModel)]="selectedUserEmployee"
                            [suggestions]="userEmployeeList" (completeMethod)="getStaffList($event)" field="name" dataKey="id"
                            [ngModelOptions]="{standalone: true}" [minLength]="1" [autoHighlight]="true"
                            (onSelect)="reloadListAfterStaffChage($event)" [forceSelection]="true"
                            (onClear)="reloadListAfterClear($event)"></p-autoComplete>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Campus:</h5>
        </div>
        <div class="col-10">
          <i *ngIf="!campusList" class="material-icons rotate text-muted">loop</i>
          <p-select styleClass="app-select ml-2 w-100 mb-2" [options]="campusList" [(ngModel)]="campusId" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>Status:</h5>
        </div>
        <div class="col-10">
          <p-select styleClass="app-select ml-2 w-100 mb-2" [options]="statusOptions" [(ngModel)]="meetsRequirements" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-select>
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>From Date:</h5>
        </div>
        <div class="col-10">
          <input type="date" class="form-control ml-2 w-100 mb-2" [(ngModel)]="startDate" (blur)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}" />
        </div>
      </div>

      <div class="row">
        <div class="col-2 d-flex align-items-center">
          <h5>To Date:</h5>
        </div>
        <div class="col-10">
          <input type="date" class="form-control ml-2 w-100 mb-2" [(ngModel)]="endDate" (blur)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}" />
        </div>
      </div>

      <div class="row mb-1">
        <div class="col-2 d-flex align-items-center">
          <h5>Show Separated Users:</h5>
        </div>
        <div class="col-10 ">
          <p-selectButton styleClass="w-100 ml-2" [options]="yesNoAllOptions" [(ngModel)]="terminatedEmployeesFilter" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-selectButton>
        </div>
      </div>

      <div class="row mb-1">
        <div class="col-2 d-flex align-items-center">
          <h5>Show Inactive Users:</h5>
        </div>
        <div class="col-10 ">
          <p-selectButton styleClass="w-100 ml-2" [options]="yesNoAllOptions" [(ngModel)]="inactiveUsersFilter" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-selectButton>
        </div>
      </div>

    </div>

    <i [hidden]="!loadingList" class="material-icons rotate text-muted">loop</i>
    <p-table #myTable [value]="list?.result" [responsive]="true" [paginator]="true" [rows]="20"
             [totalRecords]="list?.totalRecords" [lazy]="true" (onLazyLoad)="reloadFilter($event)">
      <ng-template pTemplate="header">
        <tr>
          <th width="100px"></th>
          <th [pSortableColumn]="'PlayerName'">Employee <p-sortIcon [field]="'PlayerName'"></p-sortIcon></th>
          <th [pSortableColumn]="'Campus'">Campus <p-sortIcon [field]="'Campus'"></p-sortIcon></th>
          <th [pSortableColumn]="'TemplateDescription'">KRA Description <p-sortIcon [field]="'TemplateDescription'"></p-sortIcon></th>
          <th>Oversight User(s)</th>
          <th [pSortableColumn]="'OversightReviewDate'">Oversight Review Date <p-sortIcon [field]="'OversightReviewDate'"></p-sortIcon></th>
          <th [pSortableColumn]="'OversightScore'">Oversight Score <p-sortIcon [field]="'OversightScore'"></p-sortIcon></th>
          <th>Self Reviews</th>
          <th [pSortableColumn]="'OnActivePerformancePlan'">Active Performance Plan<p-sortIcon [field]="'OnActivePerformancePlan'"></p-sortIcon></th>
          <th [pSortableColumn]="'TrainingStartDate'">Training Start Date <p-sortIcon [field]="'TrainingStartDate'"></p-sortIcon></th>
          <th>Offer Letter</th>
          <th *ngIf="canViewHrNotes">HR Notes</th>
          <th *ngIf="hasProfitSharingFeatureSetting">Quarterly Bonus</th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-review>
        <tr>
          <td>
            <button class="btn btn-secondary mr-2" (click)="openReview(review)" title="View Oversight Review">
              <i class="fas fa-file-alt"></i>
            </button>
          </td>
          <td>
            <span class="ui-column-title">Employee</span>
            {{review.employeeLastName}}, {{review.employeeFirstName}} <span style="font-style:italic; color: red; font: 0.8rem;">{{getTerminationString(review)}}</span>
          </td>
          <td>
            <span class="ui-column-title">Campus</span>
            {{review.primaryProgram}}
          </td>
          <td>
            <span class="ui-column-title">KRA Description</span>
            {{review.templateDescription}}
          </td>
          <td>
            <span class="ui-column-title">Oversight User(s)</span>
            <span *ngFor="let o of review.oversightNames">{{o}}<br /></span>
          </td>
          <td>
            <span class="ui-column-title">Oversight Review Date</span>
            {{review.oversightReviewDate | date: 'MM/dd/yyyy'}}
          </td>
          <td>
            <span class="ui-column-title">Oversight Score</span>
            {{review.oversightScore}}
            <i *ngIf="review.oversightReviewDate !== null && review.oversightScore === 0" style="cursor: pointer;" class="far fa-unlock ml-1" title="Unlock oversight review" (click)="unlockOversightReview(review)"></i>
            <span *ngIf="review.maxScore !== null && review.maxScore < review.oversightScore" style="color: red; display: block;">***Exceeds Max Score of {{review.maxScore}}***</span>
            <span *ngIf="review.hasKraExceedingMaxScore" style="color: red; display:block;">***Has KRA exceeding max score***</span>
          </td>
          <td>
            <span class="ui-column-title">Self Review Date</span>
            <div *ngFor="let r of review.lastReviewPeriods">
              {{r.month}}
              <i *ngIf="r.completedAllTemplates" class="fas fa-check-circle text-success" title="Completed all required templates"></i>
              <i *ngIf="!r.completedAllTemplates" class="fas fa-times-circle text-danger" title="Did NOT complete all required templates"></i>
            </div>
          </td>
          <td>
            <span class="ui-column-title">Active Performance Plan</span>
            {{review.onActivePerformancePlan ? "Yes" : "No"}}
          </td>
          <td>
            <span class="ui-column-title">Training Start Date</span>
            {{(review.trainingStartDate !== null) ? (review.trainingStartDate | date: 'MM/dd/yyyy') : ""}}
          </td>
          <td>
            <span class="ui-column-title">Offer Letter</span>
            <div *ngIf="review.hasCurrentOfferLetter">
              Salary: ${{review.salary}}<br />
              Req. Hours: {{review.requiredHours}}%<br />
              PTO: ${{review.pto}} ({{review.ptoPercentage}}%)<br />
              <i class="fas fa-file-alt" (click)="openOfferLetter(review)" title="View Offer Letter" style="cursor: pointer;"></i>
            </div>
            <div *ngIf="!review.hasCurrentOfferLetter">
              N/A
            </div>
          </td>
          <td *ngIf="canViewHrNotes">
            <span class="ui-column-title">HR Notes</span>
            <div *ngIf="canEditHrNotes" style="text-align: right;">
              <button style="font-size: small;"  class="btn btn-link" (click)="addHrNote(review)" title="Add new note">                
                <i class="fas fa-plus-circle"></i>
              </button>
            </div>
            <div [innerHtml]="truncateHtmlString(review.hrNotes)" [title]="getTitleString(review.hrNotes)">

            </div>
          </td>
          <td *ngIf="hasProfitSharingFeatureSetting">
            <span class="ui-column-title">Quarterly Bonus</span>
            <div *ngIf="review.quarterlyBonus" style="display: inline-block;">
              <i *ngIf="!review.quarterlyBonus.payPeriodLocked && review.hasProfitSharing" class="fas fa-redo" style="cursor: pointer;" (click)="redoQuarterlyBonus(review.quarterlyBonus)" title="Redo quarterly bonus calculation"></i>
              <i *ngIf="review.quarterlyBonus.payPeriodLocked && review.hasProfitSharing" class="fal fa-lock" title="Pay period locked"></i>
              {{review.quarterlyBonus.payrollEndDate | date : 'MM/dd/yyyy'}}
              <i *ngIf="!review.quarterlyBonus.payPeriodLocked" class="fas fa-undo btn-link" style="cursor: pointer;" title="Remove quarterly bonus" (click)="resetQuarterlyBonus(review)"></i>
            </div>
            <div *ngIf="!review.quarterlyBonus && !review.quarterlyBonusRejectedDate && !review.showRejectedReason && review.hasProfitSharing">
              <button class="btn btn-link mr-2" (click)="toggleRejectionReason(review)" title="Does Not Meet Expectations">
                <i class="fas fa-frown-open" style="color: red; font-size: x-large;"></i>
              </button>
              <button class="btn btn-link" style="color: green;" (click)="addQuarterlyBonus(review)" title="Award new quartely bonus to next unlocked pay period">
                <i class="fas fa-hand-holding-usd" style="font-size: x-large"></i>
              </button>
            </div>
            <div *ngIf="review.quarterlyBonusRejectedDate" title="{{review.quarterlyBonusRejectedDate | date: 'MM/dd/yyyy @ h:mm:ss a'}}">
              <span style="cursor: default; font-weight: bold; font-style:italic;" >
                Rejected <i class="fas fa-undo btn-link" (click)="resetQuarterlyBonus(review)" style="cursor: pointer;" title="Undo rejection"></i>
              </span><br />
              <span style="cursor: default; font-size: 0.95em;">
                {{review.quarterlyBonusRejectedReason}}
              </span>
            </div>
            <div *ngIf="review.showRejectedReason">
              <textarea rows="3" [(ngModel)]="review.quarterlyBonusRejectedReason" [ngModelOptions]="{standalone: true}"></textarea><br />
              <button class="btn btn-link" (click)="rejectQuarterlyBonus(review)" title="Save">
                <i class="fas fa-check"></i>
              </button>
              <button class="btn btn-link" title="Cancel" (click)="toggleRejectionReason(review)">
                <i class="fas fa-times" (click)="toggleRejectionReason(review)"></i>
              </button>
            </div>
          </td>
          <td>
            <button class="btn btn-link mr-2" *ngIf="review.meetsNewOfferLetterRequirements === null || review.meetsNewOfferLetterRequirements === true" (click)="saveDoesNotMeetExpections(review)" title="Does Not Meet Expectations">
              <i class="fas fa-frown-open" style="color: red; font-size: x-large;"></i>
            </button>
            <button class="btn btn-link mr-2" *ngIf="review.meetsNewOfferLetterRequirements === null || review.meetsNewOfferLetterRequirements === false" (click)="saveOfferLetterSent(review)" title="Offer Letter Sent">
              <i class="fas fa-hand-holding-usd" style="color: green;  font-size: x-large;"></i>
            </button>
            <button class="btn btn-link mr-2" *ngIf="review.meetsNewOfferLetterRequirements !== null" (click)="saveReset(review)" title="Reset">
              <i class="fas fa-undo" style="font-size: x-large;"></i>
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft" let-state>
          Showing {{ state.first + 1 }} - {{ (state.first + state.rows) > state.totalRecords ? state.totalRecords : (state.first + state.rows) }} of {{ state.totalRecords }} entries
      </ng-template>
      <ng-template pTemplate="paginatorright">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
                <span style="color: #495057; font-size: 14px; white-space: nowrap;">Rows per page:</span>
                <p-dropdown 
                    [options]="dropdownOptions()" 
                    optionLabel="label" 
                    optionValue="value"
                    [ngModel]="myTable.rows" 
                    (onChange)="myTable.rows = $event.value; myTable.reset()">
                </p-dropdown>
            </div>
      </ng-template>
    </p-table>
  </div>
</form>

<app-edit-employee-notes></app-edit-employee-notes>
